import React, { useEffect, useState } from "react";
import { Link } from "@quintype/components";
import { ShowMoreBtn } from "../../atoms/show-more-btn";
import StarShowHide from "../../atoms/star-show-hide";
import TimeStamp from "../../atoms/time-stamp";
import "./uusimmat.m.css";

const Uusimmat = () => {
  const [loadMore, setLoadMore] = useState(5);
  const [uusimmat, setUusimmat] = useState([]);
  var [showBtn, setShowBtn] = useState(true);

  useEffect(() => {
    async function fetchAPI() {
      await fetch("/api/v1/collections/uusimmat-jurvansanomat")
        .then((res) => res.json())
        .then((json) => setUusimmat(json.items))
    }
    fetchAPI();

  }, [])

  const uusimmata = [...uusimmat || []];

  const handleLoadMore = () => {
    setLoadMore(loadMore + 5);
    if (uusimmata.length <= loadMore + 5) {
      setShowBtn(false)
    }
  }

  if (uusimmata.length < 1) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="sidebar-global" styleName="sidebar-global">
        <h2 className="top-headline" styleName="top-headline">UUSIMMAT</h2>
        <div>
          {uusimmata
            .slice(0, loadMore)
            .map((item, index) => {

              /* getting url right regarding different papers*/

              function findByKey(key, value) {
                return (item, i) => item[key] === value
              }

              let findParams = findByKey("domain-slug", "jurvan-sanomat") //change here
              let positionOfPaper = item.story.sections.findIndex(findParams)

              var parts = item.story.slug.lastIndexOf("/");
              var storySlug = item.story.slug.substring(parts + 1);

              // Check if there is section for that paper
              if (item.story.sections[positionOfPaper]) {
                var splitUrl = item.story.sections[positionOfPaper]["section-url"].split("/"); //split when slash
                var joinUrl = splitUrl.slice(3); //slice after third slug
                var finalUrl = joinUrl.join("/"); //join the remaining parts with slash
                //console.log("final url " + finalUrl + "/" + storySlug);
              }

              const accessType = item.story.access;
              const paaaihe = item.story.metadata["pääaihe"];
              return (
                <React.Fragment key={index}>
                  <Link href={
                    positionOfPaper !== -1 ? (
                      item.story.sections[positionOfPaper] ? (
                        `/${finalUrl}/${storySlug}`
                      ) : (
                        `/${item.story.sections[positionOfPaper].slug}/${storySlug}`
                      )
                    ) : (
                      `/${item.story.slug}`
                    )
                  } styleName="wrapper" className="wrapper-newest-category" key={index}>
                    {/*<HeroImage story={item.story} />*/}
                    <h2 styleName="headline" className="main-headline">
                      <span styleName="span-newest">{paaaihe && `${paaaihe} | `}</span>
                      {item.story.headline}
                      {/*<Link className="main-headline" href={`/${item.story.slug}`}>{item.story.headline}</Link>*/}
                    </h2>
                    <div styleName="section-time-wrapper" className="section-time-wrapper">
                      {/*<div>
                        <SectionTag story={item.story} />
                      </div>*/}
                      <div>
                        <TimeStamp timeStamp={item.story["published-at"]} />
                      </div>
                      <StarShowHide accessType={accessType} />
                    </div>
                  </Link>
                </React.Fragment>
              );
            })}
          {(showBtn === true && uusimmata.length > 5) &&
            <ShowMoreBtn loadMore={handleLoadMore} btnName="NÄYTÄ LISÄÄ" />
          }
        </div>
      </div>
    </React.Fragment>
  );
};

export default Uusimmat;
